const colors = {
  // Brand colors
  PictonBlue: "#40b1e5",
  AlizarinCrimson: "#e62831",

  // Primary colors
  pAccent: "#E57440",
  pAccent2: "#00ADCD",
  pAccent3: "#031E65",
  pDeep: "#338EB7",
  pLight: "#B3E0F5",
  pBg1: "#D9EFFA",
  pBg2: "#ECF7FC",

  // Accent Opacity
  pAccentO: "#CA6638",

  // Secondary colors
  sAccent: "#28E6DD",
  sDeep: "#B82027",
  sLight: "#F5A9AD",
  sBg1: "#FAD4D6",
  sBg2: "#FDEAEA",

  //news
  syellow:"#F7BC0C",
  pblue:"#041C40",

  // State colors

  // Danger
  danger: "#DC3545",
  dangerDeep: "#B3292C",
  dangerLight: "#FFE0E1",

  // Success
  success: "#28A745",
  successDeep: "#145423",
  successLight: "#A9DCB5",

  // Warning or pending
  warning: "#FFC107",
  warningDeep: "#CA833F",
  warningLight: "#FFECD9",

  // Info
  blueBright: "#17a2b8",
  blueBrightDeep: "#128293",
  blueBrightLight: "#A2DAE3",

  // Neutral colors
  black: "#2C2C2A",
  dark: "#3A3341",
  dark1: "#534D58",
  gray: "#848088",
  gray1: "#B5B3B8",
  gray2: "#CECCCF",
  grayLight: "#F0F2F2",
  white: "#FFFFFF"
};

export default colors;
